import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faEye,
  faTrash,
  faCopy,
  faSpinner,
  faQrcode
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { getStore } from "../../../AppContext";
import CellInput from "../../global/CellInput";

const moment = require("moment");

const generateTransportColumns = ({
  showTransportPdf,
  loadingPdf,
  deleteTransportInv,
  deleting,
  t,
  handleDublicateInvoice,
  loadingDuplicate
}) => {
  const {
    company: [fullCompany],
    user: [user],
  } = getStore();
  const isViewRole = user.role.id === 7;
  const userCanDuplicate = !isViewRole;
  const userCanDelete = !isViewRole;

  if (typeof t !== "function") {
    console.error("Error: t is not a function");
    return [];
  }
  const addressPoints = [
    { value: "WAREHOUSE", label: t("transportInv.warehouse")},
    { value: "EXHIBITION", label: t("transportInv.exhibition") },
    { value: "STORE", label: t("transportInv.store") },
    { value: "SALE", label: t("transportInv.sale") },
    // { value: "ANOTHER", label: "Another Person's warehouse" },
    // { value: "CUSTOMS", label: "Customs Warehouse" },
    { value: "OTHER", label: t("transportInv.other") },
  ];

  const destinationPoints = [
    { value: "WAREHOUSE", label: t("transportInv.warehouse") },
    { value: "EXHIBITION", label: t("transportInv.exhibition") },
    { value: "STORE", label: t("transportInv.store") },
    { value: "SALE", label:  t("transportInv.sale") },
    { value: "OTHER", label: t("transportInv.other") },
  ];
  const vehicleOwnershipOptions = [
    { value: "OWNER", label: t("transportInv.owner") },
    { value: "THIRDPARTY", label: t("transportInv.thirdparty") },
  ];

  const statusBody=(transportInv,exportCsv)=>{
    let badgeClass = "secondary";
    let statusLabel = "Draft";

    switch (transportInv?.status?.status) {
      case "APPROVED":
        badgeClass = "success";
        statusLabel = "Approved";
        break;
      case "ERROR":
        badgeClass = "danger";
        statusLabel = "Error";
        break;
      case "DELETED":
        badgeClass = "danger";
        statusLabel = "Deleted";
    }
    if(exportCsv) return statusLabel

    return (
      <h4 className="mb-0">
        <span className={"badge badge-" + badgeClass}>{statusLabel}</span>
      </h4>
    );
  }


  return [
    {
      header: t("invoice.type"),
      field: "type",
      style: { minWidth: "180px", maxWidth: "300px" },
      body:(transportInv)=> transportInv.type || "",
      sortable: false,
      filter: false,
      default:true,
      persisted:false,
      mobile: { priority: 1 },
    },
    {
      header: t("home.status"),
      field: "status",
      format: (transportInv)=>statusBody(transportInv,true),
      body: (transportInv)=>statusBody(transportInv),
      filter: false,
      default:true,
      persisted:true,
      mobile: { priority: 1, isBadge: true, group: "status" },
    },
    {
      header: t(["table.issueDatetime"]),
      field: "issueDate",
      style: { minWidth: "180px", maxWidth: "300px" },
      filterType: "DATE",
      filterConfig: {
          like: false,
          minMaxDate:false
      },
      formattedExportValue:true,
      body: (transportInv) =>
        transportInv?.issueDate
          ? moment(transportInv?.issueDate).format("DD/MM/YYYY HH:mm")
          : "",
      default:true,
      persisted:true,
      sortable: true,
      filter: true,
      mobile: { priority: 1, group: "dates" },
    },
    {
      header: t(["transportInv.tiOrderNumber"]),
      field: "tiOrderNum",
      style: { minWidth: "230px", maxWidth: "300px" },
      body: (transportInv) => transportInv.tiOrderNum || "",
      filter: true,
      default:true,
      sortable: true,
      persisted: true,
      mobile: { priority: 1, group: "identity" },
    },
    {
      header: t(["invoice.businessUnit"]),
      field: "businessUnitCode",
      style: { minWidth: "180px", maxWidth: "300px" },
      body: (transportInv) => transportInv.businessUnitCode || "",
      sortable: false,
      filter: true,
      default:true,
      persisted:true,
      mobile: { priority: 3 },
    },
    {
      header: t("common.tiic"),
      field: "tiic",
      style: { minWidth: "180px", maxWidth: "300px" },
      format:(row)=>row.tiic,
      body: (row) => <CellInput value={row?.tiic ?? ""} width={220} />,
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 1, isTitle: true, group: "identity" },
    },
    {
      header: t("common.ftiic"),
      field: "ftiic",
      style: { minWidth: "220px", maxWidth: "300px" },
      format:(row)=>row.ftiic,
      body: (row) => <CellInput value={row?.ftiic ?? ""} width={220} />,
      sortable: false,
      filter: true,
      persisted:true,
      default: false,
      mobile: { priority: 2, group: "reference" },
    },
    {
      header: t(["home.actions"]),
      field: "actions",
      style: { minWidth: "300px", maxWidth: "300px" },
      mobile: { priority: "action", group: "actions" },
      body: (transportInv) => (
        <div className="d-flex gap-2 mt-1">
          <div className="mr-1">
          <Link
            to={"/edit-transport-invoice/" + transportInv.id}
            className={"nav-link p-0"}
          >
            <FontAwesomeIcon icon={faEye} className="mr-1" />
            {t("common.view")}
          </Link>
          </div>

          {transportInv?.tiic && transportInv?.status?.status != "ERROR" && (
            <a
              href="#"
              style={{width:58}}
              className={
                "nav-link p-0" +
                (loadingPdf ? " disabled" : "")
              }
              onClick={(e) => {
                e.preventDefault();
                showTransportPdf(transportInv?.tiic);
              }}
            >
              <FontAwesomeIcon icon={faFilePdf} className="mr-1" />
              {t("invoice.print")}
            </a>
          )}
          {transportInv.status.id == 7 && userCanDelete && (
            <a
              href="#"
              style={{width:58}}
              className={
                "nav-link p-0" +
                (deleting ? " disabled" : "")
              }
              onClick={(e) => deleteTransportInv(e, transportInv)}
            >
              <div className="text-danger">

              <FontAwesomeIcon icon={faTrash} className="mr-1" />
              {t("common.delete")}
              </div>
            </a>
          )}
              <div className="">
                {transportInv.status.status != 'ERROR' && userCanDuplicate && <a
                href="#"
                className="nav-link p-0 d-flex align-items-center"
                onClick={()=> handleDublicateInvoice({transportInv})}
                >
                {/* <FontAwesomeIcon className="mr-1" icon={faCopy} /> */}
                  {loadingDuplicate ? <FontAwesomeIcon className='mr-1' size='lg' icon={faSpinner} spin /> :  <FontAwesomeIcon className="mr-1" icon={faCopy} />}
                  {t("invoice.duplicate")}
              </a>}
              </div>

        </div>
      ),
      filter: false,
      default:true,
      persisted:true
    },
    {
      header: "QR Url",
      field: "qrUrl",
      style: { minWidth: "150px", maxWidth: "300px" },
      body: (transportInv) => (
          <a
              href={`${transportInv?.qrUrl}`}
              target="_blank"
              className="nav-link p-0 d-flex align-items-center mr-1"
          >
              <FontAwesomeIcon size="lg" className="mr-1" icon={faQrcode} />
              {"QR Url"}
          </a>
      ),
      persisted: true,
      default: true,
      mobile: { priority: 3 },
  },
    {
      header: t("invoice.startDate"),
      field: "tiStartDate",
      filterType: "DATE",
      filterConfig: {
          like: false,
          minMaxDate:false
      },
      style: { minWidth: "180px", maxWidth: "300px" },
      formattedExportValue:true,
      body: (transportInv) =>
        transportInv?.tiStartDate
          ? moment(transportInv?.address[0].date).format("DD/MM/YYYY HH:mm")
          : "",
      filter: true,
      default:true,
      persisted:false,
      sortable: true,
      mobile: { priority: 2 },
    },
    {
      header: t('invoice.Spoint'),
      field: "startingPoint",
      style: { minWidth: "180px", maxWidth: "300px" },
      sortable: false,
      formattedExportValue: true,
      body: (transportInv) => t(`transportInv.${transportInv?.startingPoint?.toLowerCase()}`,transportInv?.startingPoint),
      filterType: "DROPDOWN",
      filterConfig: {
          options: addressPoints,
          optionValue: "value",
          optionLabel: "label",
      },
      filter: true,
      default:false,
      persisted:false,
      mobile: { priority: 3 },
    },
    {
      header: t(["invoice.startAdr"]),
      field: "startAddress",
      style: { minWidth: "180px", maxWidth: "300px" },
      formattedExportValue: true,
      filter: true,
      default:true,
      persisted:false,
      sortable: false,
      mobile: { priority: 2 },
    },
    {
      header: t("invoice.eDate"),
      field: "tiEndDate",
      style: { minWidth: "180px", maxWidth: "300px" },
      filterType: "DATE",
      filterConfig: {
        like: false
      },
      formattedExportValue:true,
      body: (transportInv) =>
      transportInv?.tiEndDate
          ? moment(transportInv?.address[1].date).format("DD/MM/YYYY HH:mm")
      : "",
      filter: true,
      sortable: true,
      default:true,
      persisted:false,
      mobile: { priority: 2 },
    },
    {
      header: t('invoice.Epoint'),
      field: "pointOfArrival",
      style: { minWidth: "180px", maxWidth: "300px" },
      body: (transportInv) => t(`transportInv.${transportInv?.pointOfArrival?.toLowerCase()}`,transportInv?.pointOfArrival),
      filterType: "DROPDOWN",
      filterConfig: {
        options: destinationPoints,
        optionValue: "value",
        optionLabel: "label",
    },
      sortable: false,
      filter: true,
      default:false,
      persisted:false,
      mobile: { priority: 3 },
    },
    {
      header: t(["invoice.destinAddr"]),
      field: "destinationAddress",
      style: { minWidth: "180px", maxWidth: "300px" },
      formattedExportValue: true,
      filter: true,
      default:true,
      persisted:false,
      sortable: false,
      mobile: { priority: 2 },
    },
    {
      header: t("invoice.vehicleOwner"),
      field: "vehicleOwnership",
      style: { minWidth: "200px", maxWidth: "300px" },
      body: (transportInv) => t(`transportInv.${transportInv?.vehicleOwnership?.toLowerCase()}`,transportInv?.vehicleOwnership),
      sortable: false,
      filter: true,
      filterType: "DROPDOWN",
      filterConfig: {
        options: vehicleOwnershipOptions ,
        optionValue: "value",
        optionLabel: "label",
    },
      default:true,
      persisted:false,
      mobile: { priority: 3 },
    },
    {
      header: t("invoice.plate"),
      field: "vehiclePlate",
      style: { minWidth: "180px", maxWidth: "300px" },
      body:(transportInv)=> transportInv.vehiclePlate||"",
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 1 },
    },
    // {
    //   header: t(["invoice.idTransport"]),
    //   field: "transporterIdType",
    //   style: { minWidth: "220px", maxWidth: "300px" },
    //   body: (transportInv) => transportInv.transporterIdType || "",
    //   sortable: false,
    //   filter: true,
    //   default:true
    // },
    {
      header: t(["transportInv.transportID"]),
      field: "transporterId",
      style: { minWidth: "220px", maxWidth: "300px" },
      body: (transportInv) => transportInv.transporterId || "",
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 2 },
    },
    {
      header: "ERP ID",
      field: "internalId",
      style: { minWidth: "220px", maxWidth: "300px" },
      body: (transportInv) => transportInv.internalId || "",
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 2 },
    },
    {
      header: t(["transportInv.transporterName"]),
      field: "transporterName",
      style: { minWidth: "220px", maxWidth: "300px" },
      body: (transportInv) => transportInv.transporterName || "",
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 1 },
    },
    {
      header: t(["transportInv.receiverName"]),
      field: "receiverName",
      style: { minWidth: "220px", maxWidth: "300px" },
      body: (transportInv) => transportInv.receiverName || "",
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 1 },
    },
    {
      header: t(["transportInv.receiverNuis"]),
      field: "receiverNipt",
      style: { minWidth: "220px", maxWidth: "300px" },
      body: (transportInv) => transportInv.receiverNipt || "",
      sortable: false,
      filter: true,
      default:true,
      persisted:false,
      mobile: { priority: 3 },
    },
    {
      header: t(["invoice.valueOfGoods"]),
      field: "valueOfGoods",
      style: { minWidth: "220px", maxWidth: "300px" },
      body: (transportInv) => transportInv.valueOfGoods || "",
      sortable: false,
      filter: false,
      default:true,
      mobile: { priority: 2, group: "financial" },
    },
    {
      header: t(["invoice.Operator"]),
      field: "operatorCode",
      style: { minWidth: "180px", maxWidth: "300px" },
      formattedExportValue: true,
      body:(transportInv)=> transportInv?.operatorCode || "",
      persisted:false,
      filter: true,
      default:true,
      sortable: false,
      mobile: { priority: 3 },
    },
    {
      header: t(["common.username"]),
      field: "recordUser",
      style: { minWidth: "180px", maxWidth: "300px" },
      formattedExportValue: true,
      body:(transportInv)=> transportInv?.recordUser || "",
      persisted:false,
      filter: true,
      default:true,
      sortable: false,
      mobile: { priority: 3 },
    },
  ];
};

export default generateTransportColumns;